"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkMobilePlatform = void 0;
const checkMobilePlatform = () => {
    const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i,
    ];
    return toMatch.some((toMatchItem) => {
        return navigator.userAgent.match(toMatchItem);
    });
};
exports.checkMobilePlatform = checkMobilePlatform;
//# sourceMappingURL=mobilePlatform.js.map